import { DependenciesInjection } from "app/di/DependencyInjection";
import { PackageRegistrationImpl } from "features/packageRegistration/data/PackageRegistrationImpl";
import { IPackageRegistrationRepository } from "features/packageRegistration/domain/repositories/IPackageRegistrationRepository";
import { PackageRegistrationUseCase } from "features/packageRegistration/domain/useCases/PackageRegistrationUseCase";
import { PackageRegistrationViewModel } from "features/packageRegistration/presentation/viewModel/PackageRegistrationViewModel";
import { PackageRegistrationToken } from "features/packageRegistration/di/PackageRegistrationToken";

export class PackageRegistrationInjection {
  static initInjections(): void {
    DependenciesInjection.register<IPackageRegistrationRepository>(
      PackageRegistrationToken.IPackageRegistrationRepository,
      PackageRegistrationImpl,
      "otherRepo",
    );
    DependenciesInjection.register<PackageRegistrationUseCase>(
      PackageRegistrationToken.PackageRegistrationUseCase,
      PackageRegistrationUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<PackageRegistrationViewModel>(
      PackageRegistrationToken.PackageRegistrationViewModel,
      PackageRegistrationViewModel,
      "viewModel",
    );
  }

  static getPackageRegistrationRepo(): IPackageRegistrationRepository {
    return DependenciesInjection.getRepo<IPackageRegistrationRepository>(
      PackageRegistrationToken.IPackageRegistrationRepository,
    );
  }

  static getPackageRegistrationUseCase(): PackageRegistrationUseCase {
    return DependenciesInjection.getRepo<PackageRegistrationUseCase>(
      PackageRegistrationToken.PackageRegistrationUseCase,
    );
  }
}
